import type {
  VirtualTourDoc,
  VirtualTourListingDoc,
} from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type TourListing = Omit<
  VirtualTourListingDoc,
  'virtualTour' | 'listing'
> & { virtualTour: string; listing: string; id: string };
export type AxiosGetVirtualTour = JsonObject<{
  virtualTours: VirtualTourDoc[];
  tourListings: TourListing[];
}>;

const getVirtualToursByUser = async (coopId: string | undefined) => {
  const config: AxiosRequestConfig = {
    url: `/virtual_tour`,
    method: 'get',
    params: { coopId },
  };

  const { data } = await axios.request<AxiosGetVirtualTour>(config);

  return data;
};

export default getVirtualToursByUser;
